function initGatedAccess(passwords, key, accessWindow, resourceKey) {
  const validEntryPasswords = Array.isArray(passwords)
    ? passwords
    : (typeof passwords === 'string'
        ? passwords.split(',').map(s => s.trim()).filter(Boolean)
        : []);

  const cookieName = `gated_access_${resourceKey}`;

  const onReady = () => {
    const accessSection = document.querySelector('.gated_access_page');
    const page = document.querySelector('#MainContent');
    const passwordField = document.querySelector('input[name="enter"]');
    const submitButton = document.querySelector('.gated-access__entry-submit');
    const errorMessage = document.querySelector('.gated-access__entry-error');

	  if (validEntryPasswords.length === 0) return

    const isGranted = document.cookie.split('; ').some(c => c === `${cookieName}=granted`);
    if (isGranted) {
      accessSection.style.display = 'none';
      page.querySelectorAll(':scope > *:not(.gated_access_page)').forEach(el => el.removeAttribute('hidden'));
    } else {
      accessSection.style.display = 'block';
      page.querySelectorAll(':scope > *:not(.gated_access_page)').forEach(el => el.setAttribute('hidden', ''));
    }

    submitButton.addEventListener('click', async () => {
      const passwordEntered = (passwordField.value || '').trim();
      if (!passwordEntered) return;

      const secret = `${key}`;
      const userEntryHash = await computeHmacSHA1(secret, passwordEntered);

      if (validEntryPasswords.includes(userEntryHash)) {
        const days = accessWindow ?? 7;
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = `${cookieName}=granted; expires=${date.toUTCString()}; path=/`;

        document.documentElement.classList.remove('gate-closed');
        document.documentElement.classList.add('gate-open');

        window.location.reload();

        errorMessage.style.display = "none";
      } else {
        errorMessage.style.display = "block";
        passwordField.addEventListener('input', function () {
          errorMessage.style.display = "none";
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }
}

async function computeHmacSHA1(key, message) {
  const encoder = new TextEncoder();
  const cryptoKey = await crypto.subtle.importKey('raw', encoder.encode(key), { name: 'HMAC', hash: 'SHA-1' }, false, ['sign']);
  const signature = await crypto.subtle.sign('HMAC', cryptoKey, encoder.encode(message));
  return Array.from(new Uint8Array(signature)).map(b => b.toString(16).padStart(2, '0')).join('');
}
